import { Base } from '@studiometa/js-toolkit';

/**
 * NameGuideFilter component
 */
export default class NameGuideFilter extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'NameGuideFilter',
    refs: ['placeholder', 'checkbox[]'],
    options: {
      placeholder: {
        type: String,
        default: '',
      },
    },
  };

  /**
   * Return all the checked values or the default placeholder text
   * @returns {Array}
   */
  get checkedValues() {
    const checkedValues = this.$refs.checkbox
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.dataset.value);

    if (checkedValues.length > 0) {
      return checkedValues;
    }

    return [this.$options.placeholder];
  }

  /**
   * update placeholder fn
   */
  updatePlaceholder() {
    this.$refs.placeholder.innerHTML = this.checkedValues.join(', ');
  }

  /**
   *
   */
  onCheckboxChange() {
    this.updatePlaceholder();
  }
}
